<div class="home-card app-widget-publication">

    <div class="title carousel-control">
        <h3>{{ 'home.widgetPublication.title' | translate}}</h3>

        <div class="carousel-control-btn d-none d-md-flex">
            <button type="button" data-target="#carouselPublications" data-slide="prev"
                [disabled]="publications.length<=1">
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button type="button" data-target="#carouselPublications" data-slide="next"
                [disabled]="publications.length<=1">
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>
    </div>

    <div id="carouselPublications" class="carousel slide" data-ride="carousel" data-interval="false">
        <div class="carousel-inner">

            <ng-container *ngIf="publications.length > 0 && !isLoading">
                <div id='{{ publication.id }}' class="carousel-item"
                    *ngFor="let publication of publications; let isFirst = first" [class.active]="isFirst">
                    <div class="d-flex flex-md-row flex-column">

                        <div class="left-infos">

                            <div class="owner">
                                <app-user-avatar [firstName]="publication.owner.firstName"
                                    [lastName]="publication.owner.lastName"
                                    [picture]="publication.owner.pictureAccessLink"></app-user-avatar>

                                <p>
                                    {{ publication.owner.firstName }} {{ publication.owner.lastName }}<br>
                                    <span class="d-none d-md-block font-detail">{{ 'home.widgetPublication.in' |
                                        translate}} {{
                                        publication.clubName }}</span>
                                </p>
                            </div>


                            <div class="reactions d-none d-md-flex">

                                <p class="font-detail">
                                    <ng-container *ngIf="publication.commentsCount!==0; else noComment">

                                        {{ publication.commentsCount }} {{ (publication.commentsCount <= 1
                                            ? "home.widgetPublication.comment" : "home.widgetPublication.comments" ) |
                                            translate }} </ng-container>

                                            <ng-template #noComment>
                                                {{ "home.widgetPublication.noComment" | translate }}
                                            </ng-template>
                                </p>

                                <span *ngFor="let reaction of publication.reactions">
                                    {{ reaction.code }}
                                    {{ reaction.count }}
                                </span>

                            </div>
                        </div>

                          <app-html-content-truncate tabindex="0" [content]="publication.content" [disabled]="true" [style.cursor]="'pointer'" (click)="goToPublication(publication.clubId, publication.id)" class="content"></app-html-content-truncate>

                        <div class="reactions d-flex d-md-none"> <!-- mobile reactions -->

                            <p class="font-detail">
                                <ng-container *ngIf="publication.commentsCount!==0; else noComment">

                                    {{ publication.commentsCount }} {{ (publication.commentsCount <= 1
                                        ? "home.widgetPublication.comment" : "home.widgetPublication.comments" ) |
                                        translate }} </ng-container>

                                        <ng-template #noComment>
                                            {{ "home.widgetPublication.noComment" | translate }}
                                        </ng-template>
                            </p>

                            <span *ngFor="let reaction of publication.reactions">
                                {{ reaction.code }}
                                {{ reaction.count }}
                            </span>

                        </div>

                    </div>
                </div>
            </ng-container>

            <!-- SKELETON START -->
            <div class="carousel-item active" *ngIf="isLoading">
                <div class="d-flex flex-md-row flex-column">
                    <div class="left-infos d-none d-md-flex">

                        <div class="owner">
                            <p-skeleton shape="circle" size="42px"></p-skeleton>

                            <p>
                                <p-skeleton class="mb-2 d-flex" width="8rem"></p-skeleton>
                                <p-skeleton width="6rem" height="0.9rem"></p-skeleton>
                            </p>
                        </div>



                        <div class="reactions-skeleton">
                            <!-- <span>
                                <i class="pi pi-comments"></i>
                                {{ publication.commentCount }}
                            </span> -->
                            <p-skeleton width="7rem" height="0.9rem"></p-skeleton>

                            <p-skeleton width="3rem" height="30px" borderRadius="16px"></p-skeleton>
                            <p-skeleton width="3rem" height="30px" borderRadius="16px"></p-skeleton>
                            <p-skeleton width="3rem" height="30px" borderRadius="16px"></p-skeleton>
                        </div>
                    </div>

                    <div class="content d-flex flex-column">
                        <p-skeleton class="mb-1"></p-skeleton>
                        <p-skeleton class="mb-1"></p-skeleton>
                        <p-skeleton class="mb-1"></p-skeleton>
                        <p-skeleton class="mb-1"></p-skeleton>
                        <p-skeleton class="mb-1" width="50%"></p-skeleton>
                    </div>

                </div>

            </div>
            <!-- SKELETON END -->
            <p class="empty-state" *ngIf="publications.length <= 0 && !isLoading">{{ "home.widgetPublication.emptyState" | translate }}</p>

        </div>

    </div>

    <div class="mobile-bottom-actions d-md-none">

        <div class="mobile-controler">
            <button class="btn btn-secondary" type="button" data-target="#carouselPublications"
                [disabled]="publications.length<=1" data-slide="prev">
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button class="btn btn-secondary" type="button" data-target="#carouselPublications"
                [disabled]="publications.length<=1" data-slide="next">
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>
    </div>
</div>